// @flow
import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import FeedItem from '../FeedItem/feedItem'
import { fetchMoreFeedResult } from '../../actions/feed'
import type { SombiFeedResultProps } from '../../types'
import styles from './feedlist.css'

type Props = {
  results: Array<SombiFeedResultProps>,
  count: number,
  pages: number,
  page: number,
  dispatch: Function
}

class FeedList extends PureComponent {
  props: Props

  onShowMoreClick = (e: Object): void => {
    e.preventDefault()
    this.props.dispatch(fetchMoreFeedResult())
  }

  render () {
    const { results, pages, page, count } = this.props
    return (
      <div className={styles.feedListContainer}>
        <p className={styles.feedCount}><strong>{count}</strong> personer har takket læreren sin. Se de rørende hilsenene her:</p>
        <ul className={styles.feedlist}>
          {typeof results !== 'undefined' && results.map((result) => (
            <FeedItem
              key={result.id}
              id={result.id}
              municipality={(typeof result.geoLocation !== 'undefined' ? result.geoLocation.properties.name : '')}
              title={result.title}
              datetime={result.dates.saved.sec}
              name={result.user.fullname} />
          ))}
        </ul>
        {page < pages && (
          <div className='nrk-pagination'>
            <button onClick={this.onShowMoreClick} className='nrk-button'>Vis flere</button>
          </div>
        )}
      </div>
    )
  }
}

export default connect((state) => {
  return {
    results: state.feed.results,
    count: state.feed.count,
    pages: state.feed.pages,
    page: state.feed.page
  }
})(FeedList)



// WEBPACK FOOTER //
// ./src/shared/components/FeedList/feedList.js